// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3khVV","clinicsSelect":"TableHeading_clinicsSelect__23iUu"};